var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social",attrs:{"id":"social"}},[_c('div',{staticClass:"elfsight-app-feb345f7-9ed3-4802-921f-d38cac200551"})])}]

export { render, staticRenderFns }